import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import i18next from "i18next";

const Body = (props) => {

    const cls = useRptAF();
    const { data,num } = props;
    const cellS = {
        padding: "0px 2px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.8rem",
        width: "32%",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
    };

    const cellSD4 = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        border: "solid 0.1px",
        fontSize: "0.7rem",
        width: "32%",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        direction: "rtl",
    };
    var columns2 = [
        { title: "No \n م", field: "no" },
        { title: "Description \n الوصف", field: "notesD", cellStyle: cellSD4 },
        { title: "Unit \n الوحدة", field: "unit_name", },
        { title: "Quantity \n الكمية ", field: "val1" },
        { title: "Price \n السعر ", field: "new_exchange_price", },
        { title: "Discount \n الخصم ", field: "discount", },
        { title: "Vat \n الضريبة ", field: "taxval", },
        { title: "NetAmount \n الاجمالي ", field: "tot_net_curr" },
    ];
    var columns = [
        { title: "No \n م", field: "no" },
        { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
        { title: "Unit \n الوحدة", field: "unit_name", },
        { title: "Qoantity \n الكمية ", field: "val1" },
        { title: "Price \n السعر ", field: "new_exchange_price", },
        { title: "Discount \n الخصم ", field: "discount", },
        { title: "Vat \n الضريبة ", field: "taxval", },
        { title: "NetAmount \n الاجمالي ", field: "tot_net_curr" },
    ];
    var columns3 = [
        { title: "No \n م", field: "no" },
        { title: "Barcode \n الباركود", field: "barcode" },
        { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
        { title: "Unit \n الوحدة", field: "unit_name", },
        { title: "Qoantity \n الكمية ", field: "val1" },
        { title: "Price \n السعر ", field: "new_exchange_price", },
        { title: "Vat \n الضريبة ", field: "taxval", },
        { title: "NetAmount \n الاجمالي ", field: "tot_net_curr" },
    ];

    return (
        <Grid item container className={cls.rootBdy} style={{ direction: "ltr" }}>
            <Grid item container
                style={{
                    paddingTop: "0.5rem", direction: i18next.language == "ar" ? "rtl" : "ltr",
                }}>
                <Grid
                    item
                    xs={12}
                >
                    <MaterialTable
                        style={{ boxShadow: "none",width:"100%",tableLayout:"fixed" }}
                        options={{
                            showTitle: false,
                            toolbar: false,
                            sorting: false,
                            selection: false,
                            searchFieldAlignment: "left",
                            searchFieldVariant: "outlined",
                            showSelectAllCheckbox: false,
                            showTextRowsSelected: false,
                            pageSize: 5,
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            headerStyle: {
                                ...stElemnt.AF.header,
                                backgroundColor: colors.grey[100],
                                fontWeight: "bold",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                                border: "solid 0.1px",
                                fontSize: "1rem",
                            },
                            paging: false,
                            cellStyle: {
                                ...stElemnt.AF.cell,
                                padding: "0px 2px",
                                fontSize: "1rem",
                                fontWeight: "bold"
                            },
                        }}
                        localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
                        columns={num=== 18 ? (columns2.map(column => ({
                            ...column,
                            title: column.title.split("\n").map((line, index) => (
                                <div key={index}>{line}</div>
                            )),

                        }))) :num=== 29 ? (columns3.map(column => ({
                            ...column,
                            title: column.title.split("\n").map((line, index) => (
                                <div key={index}>{line}</div>
                            )),

                        }))) :
                            (columns.map(column => ({
                                ...column,
                                title: column.title.split("\n").map((line, index) => (
                                    <div key={index}>{line}</div>
                                )),
                            })))
                        }
                        data={data}
                    />
                </Grid>

            </Grid>

        </Grid>
    );
};

export default Body;
